import { toast } from 'react-toastify';
import { call, fork, put, takeLatest } from 'redux-saga/effects';
import * as actions from './Actions';
import * as api from './Api';
import Types from './Types';

function* getAllQuestionsBank({ payload }) {
    try {
        yield put(actions.addQuestionBankLoading(true));
        const result = yield call(api.getAllQuestionsBank, payload);
        yield put(actions.getAllQuestionsBankSuccess(result.data));
    } catch (error) {
        const { response, message } = error;
        toast.error(error);
        yield put(actions.getAllQuestionsBankFail());
    } finally {
        yield put(actions.addQuestionBankLoading(false));
    }
}



//Edit Tables
function* editQuestionBank({ payload }) {
    try {
        if (!payload?.silent) yield put(actions.addQuestionBankLoading(true));
        const result = yield call(api.editQuestionBank, payload);
        yield put(actions.editQuestionBankSuccess(result.data));
        toast.success('Edit Successfully');
        payload?.action && payload?.action()
    } catch (error) {
        yield put(actions.editQuestionBankFail());
    } finally {
        if (!payload?.silent) yield put(actions.addQuestionBankLoading(false));
        payload?.onFinally && payload.onFinally();
    }
}

// create
function* createQuestionBank(formData) {
    try {
        yield put(actions.addQuestionBankLoading(true));
        const result = yield call(api.createQuestionBank, formData.payload);
        yield put(
            actions.createQuestionBankSuccess({
                data: result.data
            })
        );
        toast.success('Created Successfully');
        formData?.action && formData?.action()
    } catch (error) {
        yield put(actions.createQuestionBankFail());
    } finally {
        yield put(actions.addQuestionBankLoading(false));
    }
}

function* deleteQuestionBank({ payload }) {
    try {
        yield put(actions.suspendQuestionBankLoading(true));
        const result = yield call(api.deleteQuestionBank, payload);

        yield put(actions.deleteQuestionBankSuccess({ payload, result }));

        toast.success('Suspended Successfully');
    } catch (error) {
        const { response, message } = error;
        toast.error(error.response);
        yield put(actions.deleteQuestionBankFail());
    } finally {
        yield put(actions.suspendQuestionBankLoading(false));
    }
}

function* bookmarkQuestionBank({ payload }) {
    try {
        yield put(actions.bookmarkQuestionBankLoading(true));
        const result = yield call(api.bookmarkQuestionBank, payload);

        yield put(actions.bookmarkQuestionBankSuccess({ payload, result }));

        toast.success('Bookmark Successfully');
    } catch (error) {
        const { response, message } = error;
        toast.error(error.response);
        yield put(actions.bookmarkQuestionBankFail());
    } finally {
        yield put(actions.bookmarkQuestionBankLoading(false));
    }
}

function* getTopMissedQuestionsForAdmin() {
    try {
        yield put(actions.addQuestionBankLoading(true));
        const result = yield call(api.getTopMissedQuestionsForAdmin);
        yield put(actions.getTopMissedQuestionsForAdminSuccess(result.data));
    } catch (error) {
        const { response, message } = error;
        toast.error(error);
        yield put(actions.getTopMissedQuestionsForAdminFail());
    } finally {
        yield put(actions.addQuestionBankLoading(false));
    }
}

function* updateQuestionTags({ payload }) {
    try {
        yield put(actions.updateQuestionTagsLoading(true));
        const result = yield call(api.updateQuestionTags, payload.id, payload.tags);
        yield put(actions.updateQuestionTagsSuccess(result.data));
        toast.success('Tags updated successfully');
    } catch (error) {
        const { response, message } = error;
        toast.error(error);
        yield put(actions.updateQuestionTagsFail());
    } finally {
        yield put(actions.updateQuestionTagsLoading(false));
    }
}

function* splitPdfQuestions({ payload }) {
    try {
        yield put(actions.splitPdfQuestionsLoading(true));
        const result = yield call(api.splitPdfQuestions, payload);
        const body = result?.data;
        const data = body?.questions ? body : (body?.data || body);
        yield put(actions.splitPdfQuestionsSuccess(data));
    } catch (error) {
        const message =
            error?.response?.data?.message ||
            error?.response?.data?.detail ||
            (Array.isArray(error?.response?.data?.notes) ? error.response.data.notes.join(' ') : null) ||
            error?.message ||
            'Failed to split PDF';
        toast.error(message);
        yield put(actions.splitPdfQuestionsFail());
    } finally {
        yield put(actions.splitPdfQuestionsLoading(false));
    }
}

function* bulkCreateQuestionBank({ payload, action }) {
    try {
        yield put(actions.addQuestionBankLoading(true));
        const result = yield call(api.bulkCreateQuestionBank, payload);
        const created = result?.data?.data ?? [];
        const count = Array.isArray(created) ? created.length : 0;
        yield put(actions.bulkCreateQuestionBankSuccess(created));
        toast.success(`Imported ${count} question${count === 1 ? '' : 's'} successfully`);
        action && action();
    } catch (error) {
        const message = error?.response?.data?.message || error?.message || 'Failed to import questions';
        toast.error(message);
        yield put(actions.bulkCreateQuestionBankFail());
    } finally {
        yield put(actions.addQuestionBankLoading(false));
    }
}

export default function* QuestionBankSaga() {
    yield takeLatest(Types.GET_QUESTIONS_BANK_REQUEST, getAllQuestionsBank);
    yield takeLatest(Types.EDIT_QUESTION_BANK_REQUEST, editQuestionBank);
    yield takeLatest(Types.CREATE_QUESTION_BANK_REQUEST, createQuestionBank);
    yield takeLatest(Types.DELETE_QUESTION_BANK_REQUEST, deleteQuestionBank);
    yield takeLatest(Types.BOOKMARK_QUESTION_BANK_REQUEST, bookmarkQuestionBank);
    yield takeLatest(Types.GET_TOP_MISSED_QUESTIONS_FOR_ADMIN_REQUEST, getTopMissedQuestionsForAdmin);
    yield takeLatest(Types.UPDATE_QUESTION_TAGS_REQUEST, updateQuestionTags);
    yield takeLatest(Types.SPLIT_PDF_QUESTIONS_REQUEST, splitPdfQuestions);
    yield takeLatest(Types.BULK_CREATE_QUESTION_BANK_REQUEST, bulkCreateQuestionBank);

}
